import {FormularioResponse, IElementos, IFormUpdate, IGetInscritos, IInscricao, IPostInscricaoResponse} from './types'
import {apiSlice} from '..'
import {getToken} from 'shared/utils/getToken'
import { IPostInscricaoRequest, UploadFile } from '../inscricao/types'

interface IFiltros {
  email?: string
  trilha?: string
  edicao?: string
  quantidadePaginas?: number
  pagina?: number
  tamanho?: number
  url?: string
}

const inscricaoSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getCandidatos: build.query<IInscricao, IGetInscritos>({
      query: data => ({
        url: 'inscricao',
        method: 'GET',
        params: {
          pagina: data.pagina,
          tamanho: 20,
          sort: 'idInscricao',
          order: 0
        },
        headers: { Authorization: `Bearer ${getToken()}` }
      }),
      providesTags: ["Inscricoes"]
    }),
    getInscricoesAbertas: build.query<boolean, void>({
      query: () => ({
        url: 'inscricao/aberta',
        method: 'GET',
      }),
    }),
    postInscricao: build.mutation<IPostInscricaoResponse, IPostInscricaoRequest>({
      query: data => ({
        url: 'inscricao',
        method: 'POST',
        body: data.body
      }),
    }),
    getInscricaoById: build.query<IElementos, number>({
      query: data => ({
        url: `inscricao/${data}`,
        method: 'GET',
        params: {id: data},
        headers: {Authorization: `Bearer ${getToken()}`}
      }),
      providesTags: (result, error, id) => [{ type: 'Inscricao', id }]
    }),
    getInscricaoFiltro: build.query<IInscricao, IFiltros>({
      query: data => ({
        url: `inscricao/filtro?${data.url}`,
        method: 'GET',
        headers: {Authorization: `Bearer ${getToken()}`}
      }),
      providesTags: ["Inscricoes"]
    }),
    deleteInscricao: build.mutation<void, number>({
      query: (id) => ({
        url: `inscricao/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Inscricao', id }, {type: "Inscricoes"}]
    }),
    uploadCurriculo: build.mutation<void, UploadFile>({
      query: (data) => ({
        url: `inscricao/curriculo/${data.idInscricao}`,
        method: "PUT",
        body: data.file,
      }),
    }),
    uploadComprovanteMatricula: build.mutation<void, UploadFile>({
      query: (data) => ({
        url: `inscricao/comp-matricula/${data.idInscricao}`,
        method: "PUT",
        body: data.file,
      }),
    }),
    uploadFile: build.mutation<void, UploadFile>({
      query: (data) => ({
        url: `inscricao/upload-print-config-pc/${data.idInscricao}`,
        method: "PUT",
        body: data.file,
      }),
    }),
    getComprovanteMatricula: build.mutation<string, number>({ 
      query: (idInscricao) => ({
        url: `inscricao/comp-matricula?idInscricao=${idInscricao}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        responseHandler: (response) => response.text(),
      }),
    }),
    getCurriculo: build.mutation<string, number>({
      query: (idInscricao) => ({
        url: `inscricao/curriculo?idInscricao=${idInscricao}`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        responseHandler: (response) => response.text(),
      }),
    }),
    updateForm: build.mutation<FormularioResponse, IFormUpdate>({
      query: (data) => ({
        url: `inscricao/atualizar-inscricao/${data.idInscricao}`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: data.inscricao,
      }),
    }),
  }),
  overrideExisting: false
})

export const {
  useGetCandidatosQuery,
  usePostInscricaoMutation,
  useUploadCurriculoMutation,
  useUploadFileMutation,
  useUploadComprovanteMatriculaMutation,
  useGetInscricaoByIdQuery,
  useLazyGetInscricaoFiltroQuery,
  useDeleteInscricaoMutation,
  useGetComprovanteMatriculaMutation,
  useGetCurriculoMutation,
  useGetInscricoesAbertasQuery,
} = inscricaoSlice
